import { DetailedLabResult } from '@pm/graphql';
import { AccordionListItem, Icon, IconTile, Text } from '@pm/ui';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { labsRoutes } from '../../modules/labs/labs-routes';
import { formatDateToLongFormYear } from '../../utilities/dateUtilities';

type LabDetailItemProps = {
  labDetail: DetailedLabResult;
};

export const LabDetailItem = ({ labDetail }: LabDetailItemProps) => {
  const { t } = useTranslation('labs');
  const navigate = useNavigate();

  const handleOpenLabDetail = () => {
    navigate(labsRoutes.result.build({ id }));
  };

  const { id, createdAt, labKit } = labDetail;
  const isFromLabKit = labKit != null;

  const formattedCreatedAt = formatDateToLongFormYear(
    new Date(createdAt),
    i18n.language,
  );

  const heading = isFromLabKit ? t('LabKit') : t('LabResults');
  const ariaLabel = isFromLabKit
    ? t('LabKitAriaLabel', { date: formattedCreatedAt })
    : t('LabResults');

  return (
    <AccordionListItem
      value={labDetail.id}
      heading={heading}
      aria-label={ariaLabel}
      grouping="joined"
      background="white"
      leadingElement={
        isFromLabKit ? (
          <img
            src="/images/lab-kit-bg.webp"
            alt={t('LabKit')}
            className="w-[40px] h-[40px] rounded-xs"
          />
        ) : (
          <IconTile icon="list_alt_check" size="large" intent="positive" />
        )
      }
      body={
        <Text size="bodyS" color="contentSubdued">
          {formattedCreatedAt}
        </Text>
      }
      onClick={handleOpenLabDetail}
      trailingElement={<Icon name="chevron_right" size="large" />}
    />
  );
};
